import { render, staticRenderFns } from "./BaseRecursiveRender.vue?vue&type=template&id=1de29d77&"
import script from "./BaseRecursiveRender.vue?vue&type=script&lang=js&"
export * from "./BaseRecursiveRender.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports